import {FormikHelpers} from "formik";

export function setFilterDates({setFieldValue}: FormikHelpers<any>, field: string, mode: string, dates: Array<string>) {
    switch (mode) {
        case 'ever':
        case 'today':
        case 'tomorrow':
        case 'yesterday':
        case 'this-week':
        case 'next-week':
        case 'last-week':
        case 'this-month':
        case 'next-month':
        case 'last-month':
            setFieldValue(field, [])
            break
        case 'between':
            setFieldValue(field, [dates[0] || '', dates[1] || ''])
            break
        default:
            setFieldValue(field, [dates[0] || ''])
    }
}